import { Popover } from '@kobalte/core/popover'
import { For, Show, type JSX } from 'solid-js'
import type { CompanySelectorScope } from 'mormaii-web-presentation/company-selector'
import Css from './company-picker.module.scss'

/**
 * A MESMA escolha, discreta: o nome da empresa abaixo de quem esta logado.
 *
 * Um combo no cabecalho anuncia uma escolha que quase nunca e feita - quem
 * administra duas empresas troca de empresa algumas vezes por dia, e nao a cada
 * tela. O nome ja estava ali dizendo em qual empresa se esta; o que faltava era
 * poder toca-lo. Assim a escolha ocupa zero espaco novo e fica onde a resposta ja
 * era lida.
 *
 * Sem campo de busca, ao contrario do {@link CompanyPicker}: aqui o conjunto e
 * FECHADO e curto - as empresas de uma pessoa -, e um campo de busca para tres
 * linhas e mobilia. O seletor cheio continua existindo para o administrador geral,
 * que escolhe entre todas.
 */
export function CompanyIdentityPicker(props: { scope: CompanySelectorScope; label?: string }): JSX.Element {
    return (
        <Popover gutter={6} placement="bottom-end" onOpenChange={(open) => open && void props.scope.onOpen()}>
            {/*
                `-mx-1 px-1`: o realce de hover encosta no texto sem deslocar a
                linha - o nome continua alinhado com o de cima quando ninguem
                esta apontando para ele.
            */}
            <Popover.Trigger aria-label="Trocar de empresa" class={Css.identity}>
                <span class={Css.identityName}>{props.scope.summary || props.label}</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class={Css.identityArrow}>
                    <path d="m6 9 6 6 6-6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </Popover.Trigger>

            <Popover.Portal>
                <Popover.Content class={Css.identityList}>
                    <p class={Css.identityTitle}>Administrando</p>

                    <For each={props.scope.options}>
                        {(option) => (
                            <Popover.CloseButton
                                aria-label={option.label}
                                onClick={() => void option.onSelect()}
                                class={Css.identityOption}
                                classList={{ [Css.current]: option.current }}
                            >
                                {/*
                                    O "check" ocupa lugar mesmo invisivel: sem isso a
                                    linha escolhida seria a unica recuada, e a lista
                                    inteira pareceria desalinhada.
                                */}
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    class={Css.check}
                                >
                                    <path d="m5 13 4 4L19 7" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span class={Css.optionTexts}>
                                    <span class={Css.optionText}>{option.label}</span>
                                    <Show when={option.note}>
                                        {(note) => <span class={Css.optionNote}>{note()}</span>}
                                    </Show>
                                </span>
                            </Popover.CloseButton>
                        )}
                    </For>
                </Popover.Content>
            </Popover.Portal>
        </Popover>
    )
}
